<template>
  <div>
    <Header />
    <Breadcrumbs title="SHOP" subTitle="ORDER HISTORY" />
    <section class="loading-container" v-if="!order_history">
      <img
        :src='require("@/assets/images/ajax-loader.gif")'
        class="img-fluid bg-img"
      />
    </section>
    <section class="section-b-space">
      <div class="container">
        <div class="checkout-page">
          <div class="checkout-form history-overflow">
            <table class="table cart-table table-striped table-responsive-xs mt-4">
              <thead class="table-head">
                <tr>
                  <th>Order ID</th>
                  <th>Total</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody class="orderhistory-table-body">
                <tr v-for="order in order_history" v-bind:key="order.internal_order_id">

                  <td style="color:#24B34C; font-weight:500;cursor: pointer;" v-b-modal="'modal-history-order-detail'+order.internal_order_id">#{{order.order_data.ordernumber}}</td>
                  <td>{{order.order_data.total_usd}}</td>
                  <td>{{order.order_day_format}}</td>

                  <b-modal
                  :id="`modal-history-order-detail${order.internal_order_id}`"
                  size="md"
                  centered
                  :hide-footer="true" >
                  <template #modal-header="{ close }">
                    <img role="button" :src="require('@/assets/images/icon/close.png')" alt="close" class="close-icon" @click="close()">
                  </template>
                    <div class="tax-fee-title" style = "border-bottom: none;margin-bottom:10px;">Order Details #{{order.order_data.ordernumber}}</div>
                    <div class="tax-fee-title" style = "padding-bottom: 10px;margin-bottom:0;">{{order.order_date_format}}</div>
                    <table class="table mb-4 border-bottom">
                      <tbody>
                        <tr>
                          <ul class="qty qty-history mb-5"  v-if="order.order_data.items.length">
                            <li v-for="(item,index) in order.order_data.items" :key="index" class="d-block">
                              <div class="row mt-3">
                                <div class="col-8 pl-4 d-flex align-items-start">
                                  <img
                                    :src='item.photourl'
                                    alt="no-image"
                                    width="80"
                                    height="80"
                                    class="mr-3"
                                    style="object-fit: contain;"
                                  />
                                  <div class="d-inline-block">
                                    <label class="d-block mb-0">{{item.productname}}</label>
                                    <label class="d-block mb-0">Qty: {{item.quantity * item.qty_cs}} Units</label>
                                    <label class="d-block mb-0">{{item.rebate_text}}</label>
                                  </div>
                                </div>
                                <div class="col-4">
                                  <label class="d-block mb-0 mt-4">${{item.price_quantity}}</label>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </tr>
                      </tbody>
                    </table>

                    <table class="sub-total" style="width:100%;" align="center" v-if="order.order_data.items.length">
                      <tbody>
                        <tr>
                          <td>
                            <h4 class="mb-0" style="color: red;">Reward Points Earned</h4>
                          </td>
                          <td class="text-right">
                            <h4 class="mb-0" style="color: red;">{{number_with_commas(order.order_data.total_reward_points)}}</h4>
                          </td>
                        </tr>
                        <tr style="line-height:28px;font-weight:500;font-size:14px;" >
                          <td>
                            <div>Order Total</div>
                          </td>
                          <td class="text-right">
                            <div>{{order.order_data.total_usd}}</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div class="col-12 mb-2">
                      <div class="row order-success-sec">
                        <div class="col-sm-12">
                          <h4>Delivery Address</h4>
                          <ul class="order-detail">
                            <li class="overflow-hidden">{{order.delivery_address.firstname}} {{order.delivery_address.lastname}}</li>
                            <li class="overflow-hidden">{{order.delivery_address.address1}}</li>
                            <li class="overflow-hidden" v-if="order.delivery_address.address2">{{order.delivery_address.address2}}</li>
                            <li class="overflow-hidden">{{order.delivery_address.city}}, {{order.delivery_address.state}} {{order.delivery_address.zip}}</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                  </b-modal>

                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Header from '@/components/header'
import Breadcrumbs from '@/components/widgets/cart-breadcrumbs'
import * as api from '@/api'

export default {
  data() {
    return {
      counter: 1
    }
  },
  components: {
    Header,
    Breadcrumbs
  },
  computed: {
    ...mapGetters({
       order_history:'cart/order_history',
       getDetail: 'products/getProductByProductId',
       getAuth: 'auth/getAccessToken',
       webTotalTitle: 'cart/webTotalTitle'
    })
  },
  methods: {
    number_with_commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  async mounted() {
     var  {dispatch} = this.$store
     var orderhistory = await api.orderHistory({limit:20,order_id:''},{'authorization':this.getAuth})
     dispatch('cart/setOrderhistory', orderhistory)
  }

}
</script>
